export default __webpack_public_path__ + "static/media/profile.f137b881.svg";